import { useEffect, useState } from "react";
import { Form, Input, Button, Modal, message, Select, Cascader, Checkbox, Upload,Radio } from 'antd';
// import { encode } from 'js-base64';
import { post, get } from "../../../component/fetch"
import { useLocation } from "react-router-dom";
import Style from "./index.module.scss"
// import type { TabsProps } from 'antd';
// import style from "./index.module.scss"
// import CheckBox from "../checkBox";
import store from "src/reducers"
import { IsPc } from "src/utils";
import { isInApp } from "src/utils/web-call-app";
export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
// const { Option } = Select
// const { Search } = Input;
/**
 * 报名弹窗组件
 */
function SignUp(props: any) {
    // const [checkValue, setCheckValue] = useState('住院医师')
    const userInfo:any = store.getState().userInfo
    const [fileList, setFileList] = useState([])
    const [baseList, setBaseList] = useState([])
    const [provinceList, setProvinceList] = useState([])
    const [imgUrl, setImageUrl] = useState({})
    const [pdfUploadParams, setPdfUploadParams] = useState({});
    const [form] = Form.useForm()
    const query = useQuery();
    const subjectId = query.get('subjectId') || ''
    const columnId = query.get('columnId') || ''
    // const formItemLayout = {
    //     labelCol: { span: 10 },
    //     wrapperCol: { span: 20 },
    // };
    const getFileList = () => {
        get('/shop/front/ge/column/subject/info/collect/getFieldList?subjectId=' + subjectId, {}, false).then(res => {
            setFileList(res.data.list)
        })
    }
    //表单提交
    async function submit(val: any) {
        const { region, base, name, phone } = val
        const data: any = {
            columnId,
            subjectId: subjectId,
            province:region? region[0] : '',
            name,
            phone,
            city: region? region[1] :'',
            district: region? region[2] :'',
            instituteType: base ? base[0] :'',
            instituteProvince: base ? base[1] :'',
            instituteName: base ? base[2] : '',
            extendInfo: [],
            signChannel:IsPc()?1:isInApp()?2:3
        }
        fileList.forEach(async (item: any) => {
            if (item.type === 1 && item.enName !== 'region') {
                data[item.enName] = val[item.enName]
            } else if (item.type === 2) {
                let newArr = [...data.extendInfo]
                newArr.push({ ...item, value: val[item.enName], extendId: item.id, field: item.zhName })
                data.extendInfo = newArr
            }
        })
        
        data.extendInfo = JSON.stringify(data.extendInfo)
        
       await post("/shop/front/ge/column/subject/user/save", { ...data }, false).then(res => {
            if (res.code === 0) {
                message.success('提交成功')
                props.onCancel()
               
            } else {
                message.error(res.msg)
            }
        })
    }
    //获取所属地区
    function getBaseList() {
        post("/main/trainInstitute/getChineseAndWesternMedicineInstitutes", {}, false).then(res => {
            if (res.code === 0) {
                let obj = JSON.parse(res.data)
                const getList = (obj: any) => {
                    let arr: any = Object.keys(obj)
                    let newData: any = []
                    arr.forEach((item: any) => {
                        let data: any = {}
                        data.label = item
                        data.value = item
                        if (obj[item]) {
                            if (obj[item] instanceof Array) {
                                let children: any = []
                                obj[item].forEach((it: any) => {
                                    children.push({
                                        value: it,
                                        label: it
                                    })
                                })
                                data.children = children
                            } else {
                                data.children = getList(obj[item])
                            }
                        }
                        newData.push(data)
                    })
                    return newData
                }
                const arr = getList(obj)
                setBaseList(arr)
                // setKeyList(JSON.parse(res.data.data))
            }
        })
    }
    //获取省份城市列表
    const getRegionCascadeList = () => {
        post("/main/region/getRegionCascadeList", {}, false).then(result => {
            setProvinceList(result.data)
        })
    }
    //图片上传前置方法
    function beforeUpload(file: any) {
        return new Promise((resovle, reject) => {
            if (file.type !== "image/jpeg" && file.type !== "image/png") {
                message.error("请选择正确的文件");
                reject();
            }

            if (file.size / 1024 / 1024 > 2) {
                message.error("请选择正确的文件");
                reject();
            }
            resovle(file)
        })
    }
    //获取图片路径方法
    async function uploadChange(file: any, item: any) {
        let formData = new FormData();
        formData.append("file", file.file);
        formData.append("uploadDataType", "image");
        formData.append("folder", "ge");
        // return false;
        await post("${shopPath}/api/upload/file", formData, false)
            .then((res) => {
                if (res.data.code === 0) {
                    // 短路径 shortPathFile
                    // courseData.course.originalLogo = res.data.data.shortPathFile;
                    setImageUrl(res.data.data)
                    form.setFieldsValue({
                        [item.enName]: res.data.data.shortPathFile
                    })
                } else {
                    message.error(res.data.msg)
                }
            })
            .catch(err => {
                message.error('图片上传错误,请重试')
            })
    }
    const filebeforeUpload = async (file: any) => {
        if (file.size / 1024 / 1024 > 20) {
            message.error("请选择小于20M的文件");
            return false;
        }
        await get("/main/upload/policy?ossFile=file", {}, false).then(res => {
            const { accessid, policy, signature, dir, host } = res.data;
            setPdfUploadParams({
                name: file.name,
                key: dir + "/section/" + file.name,
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: 200,
                signature: signature,
                host: host,
                "Content-Disposition": 'attachment'
            })
        })
        return true
    }
    //获取附件路径
    const onfileChange = (fileList: any, item: any) => {
        // const { name } = fileList;
        let formData = new FormData();

        for (let i in pdfUploadParams) {
            formData.append(i, pdfUploadParams[i])
        }
        formData.append("file", fileList.file);

        post(pdfUploadParams.host, formData, false).then(res => {
            let processStatu = ((res.loaded / res.total) * 100) | 0;
            setFileList([
                {
                    uid: '1', // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
                    name: pdfUploadParams.name, // 文件名
                    status: processStatu >= 100 ? 'success' : 'uploading', // 状态有：uploading done error removed，被 beforeUpload 拦截的文件没有 status 属性
                    response: '{"status": "success"}', // 服务端响应内容
                    percent: processStatu
                }
            ])
        }).then((res) => {
            form.setFieldsValue({
                [item.enName]: "/" + pdfUploadParams.key
            })
        });
    };
    useEffect(() => {
        if(props.open){
            getFileList()
            getRegionCascadeList()
            getBaseList()
        }
    }, [props.open])
    return (<Modal open={props.open} destroyOnClose zIndex={99999} title="填写报名信息" footer={null} width="40%" onCancel={() => {
        props.onCancel()
    }}>
        <div >
            <Form
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                onFinish={submit}
                initialValues={{
                    phone:userInfo.mobile||'',
                }}
            >
                <Form.Item label='姓名' name='name' rules={[{ required: true, message: '请输入姓名' }]}>
                    <Input placeholder="请输入姓名"></Input>
                </Form.Item>
                <Form.Item label='手机号' name='phone' rules={[{ required: true, message: '请输入手机号' }]}>
                    <Input placeholder="请输入手机号"></Input>
                </Form.Item>
                {fileList.map((item: any) => {
                    switch (item.fieldType) {
                        case "select":
                            let optionsList: any = []
                            item.optionsContent.split('|').forEach((ite: any) => {
                                optionsList.push({ label: ite, value: ite })
                            })
                            return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}><Select popupClassName={Style.mySelect} placeholder={item.placeholder} options={optionsList}></Select></Form.Item>
                        case "cascade":
                            if (item.enName === 'region') {
                                return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}>
                                    <Cascader popupClassName={Style.mySelect} placeholder={item.placeholder} options={provinceList} />
                                </Form.Item>
                            } else {
                                return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}>
                                    <Cascader popupClassName={Style.mySelect} placeholder={item.placeholder} options={baseList} />
                                </Form.Item>
                            }
                        case "checkbox":
                            return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}>
                                <Checkbox.Group options={item.optionsContent.split('|')}></Checkbox.Group>
                            </Form.Item>
                        case "radio":
                                return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}>
                                    <Radio.Group >
                                        {item.optionsContent.split('|').map((item:any)=>{
                                            return <Radio value={item} key={item}>{item}</Radio>
                                        })}
                                    </Radio.Group>
                                </Form.Item>
                        case "upload" :
                            if (item.enName === "photo") {
                                return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}>
                                    <Upload showUploadList={false} beforeUpload={beforeUpload} customRequest={(file: any) => uploadChange(file, item)}>
                                        {imgUrl.fullPathFile ? <img style={{ width: "100px", height: "100px" }} src={imgUrl.fullPathFile} alt="" /> : <div style={{ width: "100px", height: "100px", textAlign: "center", lineHeight: "100px", border: "1px solid #ccc", cursor: "pointer" }}>点击上传</div>}
                                    </Upload>
                                </Form.Item>
                            } else if (item.enName === "resume") {
                                return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}>
                                    <Upload
                                        maxCount={1}
                                        beforeUpload={filebeforeUpload}
                                        showUploadList={{ showRemoveIcon: false }}
                                        fileList={fileList}
                                        customRequest={(file: any) => onfileChange(file, item)}
                                    >
                                        <Button>
                                            选择文件
                                        </Button>
                                    </Upload>
                                </Form.Item>
                            }else{
                                return null
                            }
                        default:
                            return <Form.Item label={item.zhName} key={item.id} name={item.enName} rules={[{ required: item.required ? true : false, message: item.tips }]}>
                                <Input placeholder={item.placeholder}></Input>
                            </Form.Item>
                    }
                })}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button style={{width:"150px"}} type="primary" htmlType="submit">提交</Button>
                </div>
            </Form>
        </div>
    </Modal>)
}
export default SignUp